import { DesignSystemPrimitive } from 'designSystem/types';
import * as S from './styles';

interface GenericPrimitivePreviewProps {
	primitive: DesignSystemPrimitive;
}

export const GenericPrimitivePreview = ({ primitive }: GenericPrimitivePreviewProps) => {
	// Show a simple preview with the class name
	return (
		<S.PrimitivePreview>
			<div
				style={{
					fontSize: '12px',
					color: '#666',
					fontFamily:
						'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
					textAlign: 'center',
					padding: '8px',
				}}
			>
				{primitive.baseSelector}
			</div>
		</S.PrimitivePreview>
	);
};
